import { render, staticRenderFns } from "./GameDropdown.vue?vue&type=template&id=5c56ab2c&"
import script from "./GameDropdown.vue?vue&type=script&lang=js&"
export * from "./GameDropdown.vue?vue&type=script&lang=js&"
import style0 from "./GameDropdown.vue?vue&type=style&index=0&id=5c56ab2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports